import { Link } from 'react-router-dom';
import { CONTACT } from '../../data/siteData';

export const Footer = () => (
  <footer data-testid="main-footer" className="ftr">
    <div className="wrap">
      <div className="top">
        <div>
          <Link to="/" className="logo-plate" aria-label="BuildiTech home">
            <img src="/logo.png" alt="BuildiTech Engineering Consultants" />
          </Link>
          <p className="about">
            BIM engineering consultancy helping AEC teams deliver coordinated, data-driven construction projects
            with reliable BIM workflows.
          </p>
        </div>
        <div>
          <h4>Explore</h4>
          <ul>
            <li><Link to="/services" data-testid="footer-services-link">Services</Link></li>
            <li><Link to="/how-we-work">How we work</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            <li><Link to="/about">About &amp; training</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4>Contact</h4>
          <ul>
            <li><a href={`mailto:${CONTACT.email}`} data-testid="footer-email">{CONTACT.email}</a></li>
            <li>{CONTACT.address}</li>
            <li>{CONTACT.website}</li>
          </ul>
        </div>
      </div>
      <div className="bottom">
        <span>&copy; {new Date().getFullYear()} BuildiTech Engineering Consultants</span>
        <span>
          Made by{' '}
          <a href="https://dhrutalabs.com" target="_blank" rel="noopener noreferrer">DhrutaLabs.com</a>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
